module.exports = __webpack_public_path__ + "static/media/settings.3c32eaae.svg";